import { LocalizationContextType } from '../components/shared/contexts'

const FAHRENHEIT = 'fahrenheit'

const displaysFahrenheit = (localization?: LocalizationContextType): boolean =>
  localization?.temperature_scale === FAHRENHEIT

export const celsiusToFahrenheit = (celsius: number): number => (celsius * 9) / 5 + 32

export const temperatureUnit = (localization?: LocalizationContextType): string =>
  displaysFahrenheit(localization) ? '°F' : '°C'

// Readings are always stored in Celsius; a location may display Fahrenheit.
export const toDisplayTemperature = (celsius: number, localization?: LocalizationContextType): number =>
  displaysFahrenheit(localization) ? celsiusToFahrenheit(celsius) : celsius

export const formatTemperature = (
  celsius: number,
  localization?: LocalizationContextType,
  decimals = 2
): string =>
  `${toDisplayTemperature(celsius, localization).toFixed(decimals)}${temperatureUnit(localization)}`
